// @ts-ignore
import { getUserData } from "@/auth/getUserData";
// @ts-ignore
import i18n from "@/libs/i18n";
// @ts-ignore
import luxon from "@/libs/luxon";
// @ts-ignore
import router from "@/router";
// @ts-ignore
import { diff } from "@/utils/luxon";
// @ts-ignore
import { $themeBreakpoints } from "@themeConfig";
import { computed, Ref, ref } from "@vue/composition-api";
import { useBreakpoints } from "@vueuse/core";
import Vue from "vue";

interface StepInterface {
    target: string;
    header: {
        title: string;
    };
    content: string;
    href?: string; // use if you want to redirect after the corresponding step.
    params?: {
        placement?: "top" | "bottom" | "left" | "right";
        highlight?: boolean;
        enableScrolling?: boolean;
        debug?: boolean;
    };
}

interface ModuleStepsInterface {
    date: string; // ISO8601
    dependsOn?: string;
    user?: StepInterface[];
    manager?: StepInterface[];
    admin?: StepInterface[];
}

interface StepsInterface {
    [key: string]: ModuleStepsInterface;
}

const inProgress: Ref<boolean> = ref(false);

export default function useTour(moduleName: string) {
    // @todo this has to be placed in separate files, so its easier to maintain.
    const state: StepsInterface = {
        inboxActiveChat: {
            date: "2022-06-08T13:37:22.654Z", // UTC. Also enter milliseconds otherwise Luxon can't diff dates.
            user: [
                {
                    target: ".form-send-message textarea",
                    header: {
                        title: i18n.t("tour.inbox.manager.inbox.title"),
                    },
                    content: i18n.t("tour.inbox.manager.inbox.element-3"),
                    params: {
                        placement: "top",
                        enableScrolling: false,
                    },
                },
                {
                    target: ".active-chat-assign-dropdown",
                    header: {
                        title: i18n.t("tour.inbox.manager.inbox.title"),
                    },
                    content: i18n.t("tour.inbox.manager.inbox.element-4"),
                    params: {
                        placement: "bottom",
                        enableScrolling: false,
                    },
                },
                {
                    target: "#active-chat-assign-button",
                    header: {
                        title: i18n.t("tour.inbox.manager.inbox.title"),
                    },
                    content: i18n.t("tour.inbox.manager.inbox.element-5"),
                    params: {
                        placement: "bottom",
                        enableScrolling: false,
                    },
                },
                {
                    target: "#inbox-sidebar-right",
                    header: {
                        title: i18n.t("tour.inbox.manager.inbox.title"),
                    },
                    content: i18n.t("tour.inbox.manager.inbox.element-6"),
                    params: {
                        placement: "right",
                    },
                },
            ],
            manager: [
                {
                    target: ".form-send-message textarea",
                    header: {
                        title: i18n.t("tour.inbox.manager.inbox.title"),
                    },
                    content: i18n.t("tour.inbox.manager.inbox.element-3"),
                    params: {
                        placement: "top",
                        enableScrolling: false,
                    },
                },
                {
                    target: ".active-chat-assign-dropdown",
                    header: {
                        title: i18n.t("tour.inbox.manager.inbox.title"),
                    },
                    content: i18n.t("tour.inbox.manager.inbox.element-4"),
                    params: {
                        placement: "bottom",
                        enableScrolling: false,
                    },
                },
                {
                    target: "#active-chat-assign-button",
                    header: {
                        title: i18n.t("tour.inbox.manager.inbox.title"),
                    },
                    content: i18n.t("tour.inbox.manager.inbox.element-5"),
                    params: {
                        placement: "bottom",
                        enableScrolling: false,
                    },
                },
                {
                    target: "#inbox-sidebar-right",
                    header: {
                        title: i18n.t("tour.inbox.manager.inbox.title"),
                    },
                    content: i18n.t("tour.inbox.manager.inbox.element-6"),
                    params: {
                        placement: "left",
                    },
                },
            ],
            admin: [
                {
                    target: ".form-send-message textarea",
                    header: {
                        title: i18n.t("tour.inbox.manager.inbox.title"),
                    },
                    content: i18n.t("tour.inbox.manager.inbox.element-3"),
                    params: {
                        placement: "top",
                        enableScrolling: false,
                    },
                },
                {
                    target: ".active-chat-assign-dropdown",
                    header: {
                        title: i18n.t("tour.inbox.manager.inbox.title"),
                    },
                    content: i18n.t("tour.inbox.manager.inbox.element-4"),
                    params: {
                        placement: "bottom",
                        enableScrolling: false,
                    },
                },
                {
                    target: "#active-chat-assign-button",
                    header: {
                        title: i18n.t("tour.inbox.manager.inbox.title"),
                    },
                    content: i18n.t("tour.inbox.manager.inbox.element-5"),
                    params: {
                        placement: "bottom",
                        enableScrolling: false,
                    },
                },
                {
                    target: "#inbox-sidebar-right",
                    header: {
                        title: i18n.t("tour.inbox.manager.inbox.title"),
                    },
                    content: i18n.t("tour.inbox.manager.inbox.element-6"),
                    params: {
                        placement: "left",
                    },
                },
            ],
        },
        inbox: {
            date: "2022-06-08T13:37:22.654Z", // UTC. Also enter milliseconds otherwise Luxon can't diff dates.
            user: [
                {
                    target: "#top-bar-logo",
                    header: {
                        title: i18n.t("tour.inbox.manager.welcome.title"),
                    },
                    content: i18n.t("tour.inbox.user.welcome.intro", { name: getUserData().name }),
                    params: {
                        placement: "bottom",
                    },
                },
                {
                    target: "#top-bar-logo",
                    header: {
                        title: i18n.t("tour.inbox.manager.welcome.title"),
                    },
                    content: i18n.t("tour.inbox.user.outside-menu.intro", { name: getUserData().name }),
                    params: {
                        placement: "bottom",
                    },
                },
                {
                    target: "#navbar-user-dropdown",
                    header: {
                        title: i18n.t("tour.inbox.manager.outside-menu.title"),
                    },
                    content: i18n.t("tour.inbox.user.outside-menu.element-1"),
                    params: {
                        placement: "bottom",
                    },
                },
                {
                    target: "#nav-item-contacts",
                    header: {
                        title: i18n.t("tour.inbox.manager.outside-menu.title"),
                    },
                    content: i18n.t("tour.inbox.user.outside-menu.element-2"),
                    params: {
                        placement: "right",
                    },
                },
                ...(luxon.DateTime.now().toUTC().toString() > "2022-09-01T09:00:00.654Z"
                    ? [
                          {
                              target: "#nav-item-team-chat",
                              header: {
                                  title: i18n.t("tour.inbox.manager.outside-menu.title"),
                              },
                              content: i18n.t("tour.inbox.manager.outside-menu.element-10"),
                              params: {
                                  placement: "right",
                              },
                          } as StepInterface,
                      ]
                    : []),
                {
                    target: "#nav-item-support",
                    header: {
                        title: i18n.t("tour.inbox.user.outside-menu.title"),
                    },
                    content: i18n.t("tour.inbox.user.outside-menu.element-3"),
                    params: {
                        placement: "right",
                    },
                },
                {
                    target: "#nav-item-messaging-inbox",
                    header: {
                        title: i18n.t("tour.inbox.manager.outside-menu.title"),
                    },
                    content: i18n.t("tour.inbox.user.outside-menu.element-4"),
                    params: {
                        placement: "right",
                    },
                },
                {
                    target: ".chat-user-list-wrapper",
                    header: {
                        title: i18n.t("tour.inbox.manager.inbox.title"),
                    },
                    content: i18n.t("tour.inbox.user.inbox.element-1"),
                    params: {
                        placement: "right",
                        enableScrolling: false,
                    },
                },
                {
                    target: "#top-bar-logo",
                    header: {
                        title: i18n.t("tour.inbox.manager.welcome.title"),
                    },
                    content: i18n.t("tour.inbox.user.welcome.outro"),
                    params: {
                        placement: "bottom",
                    },
                },
            ],
            manager: [
                {
                    target: "#top-bar-logo",
                    header: {
                        title: i18n.t("tour.inbox.manager.welcome.title"),
                    },
                    content: i18n.t("tour.inbox.manager.welcome.intro", { name: getUserData().name }),
                    params: {
                        placement: "bottom",
                    },
                },
                {
                    target: "#top-bar-logo",
                    header: {
                        title: i18n.t("tour.inbox.manager.welcome.title"),
                    },
                    content: i18n.t("tour.inbox.manager.outside-menu.intro", { name: getUserData().name }),
                    params: {
                        placement: "bottom",
                    },
                },
                {
                    target: "#navbar-user-dropdown",
                    header: {
                        title: i18n.t("tour.inbox.manager.outside-menu.title"),
                    },
                    content: i18n.t("tour.inbox.manager.outside-menu.element-1"),
                    params: {
                        placement: "bottom",
                    },
                },
                {
                    target: "#nav-item-contacts",
                    header: {
                        title: i18n.t("tour.inbox.manager.outside-menu.title"),
                    },
                    content: i18n.t("tour.inbox.manager.outside-menu.element-2"),
                    params: {
                        placement: "right",
                    },
                },
                {
                    target: "#nav-item-support",
                    header: {
                        title: i18n.t("tour.inbox.manager.outside-menu.title"),
                    },
                    content: i18n.t("tour.inbox.manager.outside-menu.element-3"),
                    params: {
                        placement: "right",
                    },
                },
                {
                    target: "#nav-item-messaging-inbox",
                    header: {
                        title: i18n.t("tour.inbox.manager.outside-menu.title"),
                    },
                    content: i18n.t("tour.inbox.manager.outside-menu.element-4"),
                    params: {
                        placement: "right",
                    },
                },
                {
                    target: "#nav-item-team-chat",
                    header: {
                        title: i18n.t("tour.inbox.manager.outside-menu.title"),
                    },
                    content: i18n.t("tour.inbox.manager.outside-menu.element-10"),
                    params: {
                        placement: "right",
                    },
                },
                {
                    target: ".chat-user-list-wrapper",
                    header: {
                        title: i18n.t("tour.inbox.manager.inbox.title"),
                    },
                    content: i18n.t("tour.inbox.manager.inbox.element-1"),
                    params: {
                        placement: "right",
                        enableScrolling: false,
                    },
                },
                {
                    target: "#top-bar-logo",
                    header: {
                        title: i18n.t("tour.inbox.manager.outside-menu.title"),
                    },
                    content: i18n.t("tour.inbox.manager.outside-menu.element-5"),
                },
                {
                    target: "#nav-item-insights",
                    header: {
                        title: i18n.t("tour.inbox.manager.outside-menu.title"),
                    },
                    content: i18n.t("tour.inbox.manager.outside-menu.element-6"),
                    params: {
                        placement: "right",
                    },
                },
                {
                    target: "#nav-item-secure-exports",
                    header: {
                        title: i18n.t("tour.inbox.manager.outside-menu.title"),
                    },
                    content: i18n.t("tour.inbox.manager.outside-menu.element-8"),
                    params: {
                        placement: "right",
                    },
                },
                {
                    target: "#nav-item-settings",
                    header: {
                        title: i18n.t("tour.inbox.manager.outside-menu.title"),
                    },
                    content: i18n.t("tour.inbox.manager.outside-menu.element-9"),
                    href: "/settings",
                    params: {
                        placement: "right",
                    },
                },
            ],
            admin: [
                {
                    target: "#top-bar-logo",
                    header: {
                        title: i18n.t("tour.inbox.manager.welcome.title"),
                    },
                    content: i18n.t("tour.inbox.manager.welcome.intro", { name: getUserData().name }),
                    params: {
                        placement: "bottom",
                    },
                },
                {
                    target: "#top-bar-logo",
                    header: {
                        title: i18n.t("tour.inbox.manager.welcome.title"),
                    },
                    content: i18n.t("tour.inbox.manager.outside-menu.intro", { name: getUserData().name }),
                    params: {
                        placement: "bottom",
                    },
                },
                {
                    target: "#navbar-user-dropdown",
                    header: {
                        title: i18n.t("tour.inbox.manager.outside-menu.title"),
                    },
                    content: i18n.t("tour.inbox.manager.outside-menu.element-1"),
                    params: {
                        placement: "bottom",
                    },
                },
                {
                    target: "#nav-item-contacts",
                    header: {
                        title: i18n.t("tour.inbox.manager.outside-menu.title"),
                    },
                    content: i18n.t("tour.inbox.manager.outside-menu.element-2"),
                    params: {
                        placement: "right",
                    },
                },
                {
                    target: "#nav-item-support",
                    header: {
                        title: i18n.t("tour.inbox.manager.outside-menu.title"),
                    },
                    content: i18n.t("tour.inbox.manager.outside-menu.element-3"),
                    params: {
                        placement: "right",
                    },
                },
                {
                    target: "#nav-item-messaging-inbox",
                    header: {
                        title: i18n.t("tour.inbox.manager.outside-menu.title"),
                    },
                    content: i18n.t("tour.inbox.manager.outside-menu.element-4"),
                    params: {
                        placement: "right",
                    },
                },
                {
                    target: ".chat-user-list-wrapper",
                    header: {
                        title: i18n.t("tour.inbox.manager.inbox.title"),
                    },
                    content: i18n.t("tour.inbox.manager.inbox.element-1"),
                    params: {
                        placement: "right",
                        enableScrolling: false,
                    },
                },
                {
                    target: "#top-bar-logo",
                    header: {
                        title: i18n.t("tour.inbox.manager.outside-menu.title"),
                    },
                    content: i18n.t("tour.inbox.manager.outside-menu.element-5"),
                },
                {
                    target: "#nav-item-insights",
                    header: {
                        title: i18n.t("tour.inbox.manager.outside-menu.title"),
                    },
                    content: i18n.t("tour.inbox.manager.outside-menu.element-6"),
                    params: {
                        placement: "right",
                    },
                },
                {
                    target: "#nav-item-apps",
                    header: {
                        title: i18n.t("tour.inbox.manager.outside-menu.title"),
                    },
                    content: i18n.t("tour.inbox.manager.outside-menu.element-7"),
                    params: {
                        placement: "right",
                    },
                },
                {
                    target: "#nav-item-secure-exports",
                    header: {
                        title: i18n.t("tour.inbox.manager.outside-menu.title"),
                    },
                    content: i18n.t("tour.inbox.manager.outside-menu.element-8"),
                    params: {
                        placement: "right",
                    },
                },
                {
                    target: "#nav-item-settings",
                    header: {
                        title: i18n.t("tour.inbox.manager.outside-menu.title"),
                    },
                    content: i18n.t("tour.inbox.manager.outside-menu.element-9"),
                    href: "/settings",
                    params: {
                        placement: "right",
                    },
                },
            ],
        },
        settings: {
            date: "2022-06-08T13:37:22.654Z",
            manager: [
                {
                    target: "#settings-card-my-account",
                    header: {
                        title: i18n.t("tour.settings.manager.title"),
                    },
                    content: i18n.t("tour.settings.manager.element-1"),
                    params: {
                        placement: "bottom",
                    },
                },
                {
                    target: "#settings-card-users",
                    header: {
                        title: i18n.t("tour.settings.manager.title"),
                    },
                    content: i18n.t("tour.settings.manager.element-2"),
                    params: {
                        placement: "bottom",
                    },
                },
                {
                    target: "#settings-card-teams",
                    header: {
                        title: i18n.t("tour.settings.manager.title"),
                    },
                    content: i18n.t("tour.settings.manager.element-3"),
                },
                {
                    target: "#settings-card-channels",
                    header: {
                        title: i18n.t("tour.settings.manager.title"),
                    },
                    content: i18n.t("tour.settings.manager.element-4"),
                },
                {
                    target: "#settings-card-tags",
                    header: {
                        title: i18n.t("tour.settings.manager.title"),
                    },
                    content: i18n.t("tour.settings.manager.element-5"),
                },
                {
                    target: "#settings-card-smart-routing",
                    header: {
                        title: i18n.t("tour.settings.manager.title"),
                    },
                    content: i18n.t("tour.settings.manager.element-7"),
                    params: {
                        placement: "bottom",
                    },
                },
                {
                    target: "#settings-card-ip-whitelisting",
                    header: {
                        title: i18n.t("tour.settings.manager.title"),
                    },
                    content: i18n.t("tour.settings.manager.element-8"),
                    params: {
                        placement: "top",
                    },
                },
                {
                    target: "#top-bar-logo",
                    header: {
                        title: i18n.t("tour.inbox.manager.welcome.title"),
                    },
                    content: i18n.t("tour.inbox.manager.welcome.outro"),
                    params: {
                        placement: "bottom",
                    },
                },
            ],
            admin: [
                {
                    target: "#settings-card-my-account",
                    header: {
                        title: i18n.t("tour.settings.manager.title"),
                    },
                    content: i18n.t("tour.settings.manager.element-1"),
                    params: {
                        placement: "bottom",
                    },
                },
                {
                    target: "#settings-card-users",
                    header: {
                        title: i18n.t("tour.settings.manager.title"),
                    },
                    content: i18n.t("tour.settings.manager.element-2"),
                    params: {
                        placement: "bottom",
                    },
                },
                {
                    target: "#settings-card-teams",
                    header: {
                        title: i18n.t("tour.settings.manager.title"),
                    },
                    content: i18n.t("tour.settings.manager.element-3"),
                },
                {
                    target: "#settings-card-channels",
                    header: {
                        title: i18n.t("tour.settings.manager.title"),
                    },
                    content: i18n.t("tour.settings.manager.element-4"),
                },
                {
                    target: "#settings-card-tags",
                    header: {
                        title: i18n.t("tour.settings.manager.title"),
                    },
                    content: i18n.t("tour.settings.manager.element-5"),
                },
                {
                    target: "#settings-card-smart-routing",
                    header: {
                        title: i18n.t("tour.settings.manager.title"),
                    },
                    content: i18n.t("tour.settings.manager.element-7"),
                    params: {
                        placement: "bottom",
                    },
                },
                {
                    target: "#settings-card-ip-whitelisting",
                    header: {
                        title: i18n.t("tour.settings.manager.title"),
                    },
                    content: i18n.t("tour.settings.manager.element-8"),
                    params: {
                        placement: "top",
                    },
                },
                {
                    target: "#top-bar-logo",
                    header: {
                        title: i18n.t("tour.inbox.manager.welcome.title"),
                    },
                    content: i18n.t("tour.inbox.manager.welcome.outro"),
                    params: {
                        placement: "bottom",
                    },
                },
            ],
        },
        teamChat: {
            date: "2022-09-01T09:00:00.654Z",
            dependsOn: "inbox",
            manager: [
                {
                    target: "#nav-item-team-chat",
                    header: {
                        title: i18n.t("tour.team-chat.title"),
                    },
                    content: i18n.t("tour.inbox.manager.outside-menu.element-10"),
                    params: {
                        placement: "right",
                    },
                },
            ],
            admin: [
                {
                    target: "#nav-item-team-chat",
                    header: {
                        title: i18n.t("tour.team-chat.title"),
                    },
                    content: i18n.t("tour.inbox.manager.outside-menu.element-10"),
                    params: {
                        placement: "right",
                    },
                },
            ],
            user: [
                {
                    target: "#nav-item-team-chat",
                    header: {
                        title: i18n.t("tour.team-chat.title"),
                    },
                    content: i18n.t("tour.inbox.manager.outside-menu.element-10"),
                    params: {
                        placement: "right",
                    },
                },
            ],
        },
    };

    const getSteps = () => {
        if (!state[moduleName]) {
            return;
        }

        // @ts-ignore
        return state[moduleName][getUserData().role];
    };

    const hasSteps = computed(() => getSteps()?.length > 0);

    const getNewestTourDate = () => {
        return luxon.DateTime.fromISO(state[moduleName].date).toUTC().toString();
    };

    const shouldShow = () => {
        if (!state[moduleName]) {
            return false;
        }

        // No tour on mobile, because some elements are hidden.
        if (useBreakpoints($themeBreakpoints).isSmaller("lg")) {
            return false;
        }

        // do not show future tours
        if (state[moduleName].date > luxon.DateTime.now().toUTC().toString()) {
            return false;
        }

        const localStorageData: { [key: string]: string } = JSON.parse(localStorage.getItem("tourShownDate") ?? "{}");

        if (state[moduleName].dependsOn) {
            // the precedent tour has not been shown yet, no need to show this one
            if (!localStorageData[state[moduleName].dependsOn as string]) {
                return false;
            }
            // the precedent tour was shown after the release of current one, don't show
            if (localStorageData[state[moduleName].dependsOn as string] > state[moduleName].date) {
                return false;
            }
        }

        if (!localStorageData[moduleName]) {
            return true;
        }

        const tourShownDate = luxon.DateTime.fromISO(localStorageData[moduleName]).toUTC().toString();

        if (!tourShownDate || diff(tourShownDate, getNewestTourDate()).milliseconds < 0) {
            return true;
        }

        return false;
    };

    const resetLocalStorage = () => {
        return new Promise((resolve) => {
            localStorage.removeItem("tourShownDate");

            resolve(true);
        });
    };

    const restartTour = () => {
        resetLocalStorage().then(() => {
            router.go("inbox"); // by using .go, the page will hard refresh
        });
    };

    const setTourShownDate = (date: string): void => {
        const localStorageData: { [key: string]: string } = JSON.parse(localStorage.getItem("tourShownDate") ?? "{}");

        const entries = {
            ...localStorageData,
            [moduleName]: date,
        };

        localStorage.setItem("tourShownDate", JSON.stringify(entries));
    };

    const startTour = () => {
        if (!inProgress.value) {
            Vue.prototype.$tours[`${moduleName}Tour`].start();
            inProgress.value = true;
        }
    };

    const stopTour = () => {
        Vue.prototype.$tours[`${moduleName}Tour`].stop();
    };

    const dateNow = luxon.DateTime.now().toUTC().toString();

    // Will be emitted by the Vue-Tour plugin itself.
    const tourCallbacks = {
        onStart: () => {
            inProgress.value = true;
        },
        onStop: () => {
            setTourShownDate(getNewestTourDate() > dateNow ? getNewestTourDate() : dateNow);

            inProgress.value = false;
        },
        onFinish: () => {
            setTourShownDate(getNewestTourDate() > dateNow ? getNewestTourDate() : dateNow);

            inProgress.value = false;
        },
        onSkip: () => {
            setTourShownDate(getNewestTourDate() > dateNow ? getNewestTourDate() : dateNow);

            inProgress.value = false;
        },
        // onPreviousStep
        // onNextStep
    };

    return {
        getNewestTourDate,
        setTourShownDate,
        shouldShow,
        getSteps,
        restartTour,
        resetLocalStorage,
        hasSteps,
        startTour,
        stopTour,
        inProgress,
        tourCallbacks,
    };
}
